import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import FamilyMemberProfile from './FamilyMemberProfile';

loadDOMComponent({
	selector: 'react-family-member-profile',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const userId = container.getAttribute('data-userId');

		if (!userId) {
			return;
		}

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<FamilyMemberProfile userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
